let bs = {}
export default bs.config = {
    apiKey: "AIzaSyA4uUmjDDXkI_IDtSJNjkCMLFTcmHMen-A",
    authDomain: "bitscheduler-fb66d.firebaseapp.com",
    databaseURL: "https://bitscheduler-fb66d.firebaseio.com",
    projectId: "bitscheduler-fb66d",
    storageBucket: "bitscheduler-fb66d.appspot.com",
    messagingSenderId: "1041370113885",
    appId: "1:1041370113885:web:97a0e624f739f6575f6ab4"
}
